"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverGroupRouteParamsSchema = exports.UpdateDriverGroupDtoSchema = exports.CreateDriverGroupDtoSchema = exports.DriverGroupDtoSchema = void 0;
const zod_1 = require("zod");
exports.DriverGroupDtoSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    name: zod_1.z.string().min(1),
    memberIds: zod_1.z.array(zod_1.z.string().min(1)),
    createdAt: zod_1.z.string().datetime(),
});
exports.CreateDriverGroupDtoSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(1).max(100),
});
exports.UpdateDriverGroupDtoSchema = exports.CreateDriverGroupDtoSchema.extend({
    memberIds: zod_1.z.array(zod_1.z.string()),
});
exports.DriverGroupRouteParamsSchema = zod_1.z.object({
    groupId: zod_1.z.string().uuid(),
});
//# sourceMappingURL=driver-group.js.map